import { forwardRef, useRef } from 'react';
import styles from '../Inputs.module.scss.js';
import messages from '../intl/index.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useMessageFormatter } from '../../i18n/format.js';
import { useControllableState } from '../../util/useControllableState.js';
import { UNSAFE_Icon } from '../../icon/Icon.js';
import { combineRefs } from '../../util/combineRefs.js';
import { Button } from '../../button/Button.js';
import classNames from 'clsx';
import { MdSearch } from '../../node_modules/react-icons/md/index.js';
import { MdCloseSmall } from '../../icon/icons/material.js';

/**
 * A text input used for searching.
 */
const SearchTextInput = /*#__PURE__*/forwardRef(function SearchTextInput(props, forwardedRef) {
  const {
    formatMessage
  } = useMessageFormatter(messages);
  const {
    variant = 'default',
    autoComplete = 'off',
    disabled,
    name,
    readOnly,
    tag = name,
    className: callerClassName,
    value: callerValue,
    onChange: callerOnChange,
    ...inputProps
  } = props;
  const ref = useRef(null);
  const [value, onChange] = useControllableState(callerValue, '', callerOnChange);
  const containerClassName = classNames('dsx-component', styles['input-box'], styles['container'], styles['button-first'], styles['button-last'], styles['cursor-text'], styles[variant], readOnly && styles['read-only'], callerClassName);
  const inputClassName = classNames(styles['input']);
  function handleChange(e) {
    onChange(e.currentTarget.value);
  }
  function handleClear() {
    onChange('');
  }
  function handleClick() {
    ref.current?.focus();
  }
  function handleMouseDown(e) {
    if (e.target !== ref.current) {
      e.preventDefault();
    }
  }
  return /*#__PURE__*/jsxs("fieldset", {
    className: containerClassName,
    disabled: disabled,
    onClick: handleClick,
    onMouseDown: handleMouseDown,
    children: [/*#__PURE__*/jsx(UNSAFE_Icon, {
      icon: MdSearch,
      className: styles['icon']
    }), /*#__PURE__*/jsx("input", {
      ...inputProps,
      type: "text",
      autoComplete: autoComplete,
      className: inputClassName,
      readOnly: readOnly,
      ref: combineRefs(forwardedRef, ref),
      value: value,
      onChange: handleChange,
      "data-dsx--search-text-input": tag
    }), value && /*#__PURE__*/jsx(Button, {
      iconOnly: true,
      icon: MdCloseSmall,
      size: "compact",
      variant: "ui-control",
      onClick: handleClear,
      children: formatMessage('Clear')
    })]
  });
});

export { SearchTextInput };
